<template>
    <div>
        <!-- もっとを見る -->
        <more-info :item="item"></more-info>
        
        <div v-if="item.apply_flg == 't'" class="text-danger">
            <span>
                <small> 退場待ち({{converVal('exit_reason', item.exit_reason)}})</small>
            </span>
        </div>
        <div v-if="item.apply_flg == 'o'" class="text-success">
            <span>
                <small> 退場済み</small>
            </span>
        </div>
        <div class="text-muted">
            <span>
                <small> 名前: {{item.first_nm}} {{item.last_nm}} ({{item.first_kana}} {{item.last_kana}})</small>
            </span>
        </div>
        <div class="text-truncate">
            {{item.name}}
        </div>
        <div class="text-muted">
            <span>
                <small>
                    契約期間：{{formatDate(item.start_month,item.start_day)}} ~ 
                    <span v-if="isOverEnd(item.end_month,item.end_day)" class="text-danger">
                        <b>
                            {{formatDate(item.end_month,item.end_day)}}
                        </b>
                    </span>
                    <span v-else>
                        {{formatDate(item.end_month,item.end_day)}}
                    </span>
                </small>
            </span>
        </div>
    </div>
</template>

<script>
    import MoreInfo from './More'
    import {converVal} from 'pages/commons/form/selectList'
    import {isOverContractEnd} from 'pages/commons/form/comFunc'

    export default {
        components: {
            MoreInfo,
        },
        props: {
            item: Object
        },
        methods: {
            formatDate (month, day) {
                let str = month + '/' + day
                return str.replace('-', '/')
            },
            converVal (name, val) {
                return converVal(name,val)
            },
            isOverEnd (month, day) {
                let str = month + '-' + day
                return isOverContractEnd(str)
            }
        }
    }

</script>

<style>

</style>
